import React from 'react';
import { Box, Typography } from '@mui/material';

const TONES = {
    good:  { bg: 'rgba(16,185,129,0.14)',  fg: '#34d399', border: 'rgba(16,185,129,0.35)' },
    warn:  { bg: 'rgba(245,158,11,0.14)',  fg: '#fbbf24', border: 'rgba(245,158,11,0.35)' },
    crit:  { bg: 'rgba(239,68,68,0.16)',   fg: '#f87171', border: 'rgba(239,68,68,0.45)' },
    info:  { bg: 'rgba(59,130,246,0.14)',  fg: '#60a5fa', border: 'rgba(59,130,246,0.35)' },
    muted: { bg: 'rgba(148,163,184,0.16)', fg: '#cbd5e1', border: 'rgba(148,163,184,0.3)'  },
};

export default function StatPill({ tone = 'muted', icon, children, size = 'sm' }) {
    const c = TONES[tone] || TONES.muted;
    return (
        <Box sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            bgcolor: c.bg,
            color: c.fg,
            border: `1px solid ${c.border}`,
            borderRadius: 999,
            px: size === 'lg' ? 1.5 : 1,
            py: size === 'lg' ? 0.5 : 0.25,
            fontSize: size === 'lg' ? 12 : 10.5,
            fontWeight: 600,
            letterSpacing: 0.3,
            textTransform: 'uppercase',
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
        }}>
            {icon}
            <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit' }}>{children}</Typography>
        </Box>
    );
}
